import { useEffect, useState } from 'react'
import { useLanguage } from '@/hooks/useLanguage'
import { betaT } from '../locale'
import { BetaStoreButton } from './BetaStoreButton'
import {
  WEB_ICON,
  TG_ICON,
  APPLE_ICON,
  PLAY_ICON,
  X_ICON,
  SUPPORT_ICON,
} from './BetaThankYouFooterIcons'

export const BetaThankYouFooter = () => {
  const { language } = useLanguage()
  const l = betaT[language]
  const [show, setShow] = useState(false)

  useEffect(() => {
    const id = setTimeout(() => setShow(true), 3500)
    return () => clearTimeout(id)
  }, [])

  // white by design: renders on the fixed-dark Beta hero (BetaLayout), not app surface
  return (
    <div
      className="transition-all duration-700 ease-out overflow-hidden"
      style={{
        opacity: show ? 1 : 0,
        maxHeight: show ? '600px' : '0px',
        marginTop: show ? '24px' : '0px',
      }}
    >
      <div className="w-full h-px bg-white/10 mb-6" />
      <p className="text-base font-medium text-white/80 mb-4">{l.tryApp}</p>
      <div className="grid grid-cols-2 gap-3 mb-2">
        <BetaStoreButton href="https://learn.open-academy.app/" icon={WEB_ICON}>
          WEB
        </BetaStoreButton>
        <BetaStoreButton href="https://t.me/nutsfarm_bot/" icon={TG_ICON}>
          TMA
        </BetaStoreButton>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-6">
        <BetaStoreButton
          href="https://apps.apple.com/us/app/open-academy-skill-a-day/id6789161454"
          icon={APPLE_ICON}
        >
          App Store
        </BetaStoreButton>
        <BetaStoreButton
          href="https://play.google.com/store/apps/details?id=app.openacademy.mobile&pli=1"
          icon={PLAY_ICON}
        >
          Google Play
        </BetaStoreButton>
      </div>
      <p className="text-base font-medium text-white/80 mb-4">{l.followUs}</p>
      <div className="flex flex-wrap items-center gap-3">
        <a
          href="https://x.com/OpenAcademyAI"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/10 bg-white/5 text-white/80 hover:border-white/20 hover:bg-white/10 transition-all text-sm font-medium"
        >
          {X_ICON}X
        </a>
        <a
          href="https://t.me/open_academy_ru"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/10 bg-white/5 text-white/80 hover:border-white/20 hover:bg-white/10 transition-all text-sm font-medium"
        >
          {TG_ICON}
          Telegram
        </a>
        <a
          href="https://t.me/open_academy_support_bot"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/10 bg-white/5 text-white/80 hover:border-white/20 hover:bg-white/10 transition-all text-sm font-medium"
        >
          {SUPPORT_ICON}
          {l.support}
        </a>
      </div>
    </div>
  )
}
